import { toast } from 'sonner'

import { usePostRecruitmentCheckPhone } from '@/shared/api'
import { ERROR_CODE, getErrorMessage } from '@/shared/model'

export const useRecruitmentCheckPhone = () => {
    const { mutateAsync, isPending, mutate, error } = usePostRecruitmentCheckPhone({
        mutation: {
            onError: (error) => {
                if (error.error_code !== ERROR_CODE.DRIVER_NOT_FOUND) {
                    toast.error(getErrorMessage(error.error_code))
                }

                throw error
            },
        },
    })

    return {
        checkPhone: mutateAsync,
        isChecking: isPending,
        checkPhoneMutation: mutate,
        error,
    }
}
